import { parseApiDate } from '../../utils/parseApiDate';

const DEFAULT_GAP_MS = 60 * 60 * 1000;

function formatGapLabel(ms) {
  const minutes = Math.floor(ms / 60000);
  if (minutes < 60) return `${minutes} min later`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} later`;
  const days = Math.floor(hours / 24);
  return `${days} day${days === 1 ? '' : 's'} later`;
}

/**
 * Group messages into interaction clusters separated by time gaps.
 * Returns [{ type: 'divider', label }, { type: 'message', message }, ...]
 */
export function clusterMessages(messages, gapMs = DEFAULT_GAP_MS) {
  if (!messages?.length) return [];
  const out = [];
  let prevTs = null;
  messages.forEach((msg) => {
    const ts = msg.created_at ? parseApiDate(msg.created_at)?.getTime() : null;
    if (prevTs != null && ts != null && ts - prevTs >= gapMs) {
      out.push({ type: 'divider', key: `gap-${msg.id}`, label: formatGapLabel(ts - prevTs) });
    }
    out.push({ type: 'message', key: `msg-${msg.id}`, message: msg });
    if (ts != null) prevTs = ts;
  });
  return out;
}

export function displayMessageText(msg) {
  const meta = msg?.meta || {};
  if (meta.trigger_text) return meta.trigger_text;
  const content = msg?.content || '';
  const prefix = '[Replied-to message from ';
  if (content.startsWith(prefix)) {
    const idx = content.indexOf('[User message]:');
    if (idx >= 0) return content.slice(idx + '[User message]:'.length).trim();
  }
  return content;
}
